import React from 'react';
import './Injectionmakesplastic.css';
import bottleca from '../../../imgs/bottlecap.webp';

const Injectionmakesplastic = () => {
    return (
        <div className="Ordinary-container">
            <div className='Ordinarys'>
                <h2 className="Ordinary-title">Want to learn how injection molding machine makes plastic bottle caps?</h2>
                <p className="">Injection molding bottle cap process:</p>

                <p className="Ordinary-text">The suction machine sucks the mixed material into
                    the barrel of the injection molding machine, heats it in the barrel,
                    and reaches a molten state under the action of screw conveying, melting, and stirring.</p>
                <p className="Ordinary-text">Then enter the mold cavity under the action of high injection pressure,
                    cool and mold in the cavity,
                    demould, and complete the production of injection caps.</p>
                <div className="Ordinary">
                    <img src={bottleca} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Ordinary-text">The following video uses Disha
                    BJ series injection molding machine to produce flip top covers,
                    PE material, and the cycle is about 17 seconds.</p>
                <p className="Ordinary-text">The closure method of
                    the flip caps opened after injection molding is that
                    the flip caps close automatically in the mold.</p>


            </div>

        </div>
    );
};

export default Injectionmakesplastic;
